/**
 * O estado reativo do Modo de Voz/Ditar — um `Vue` isolado usado como mini-
 * store (mesmo padrão do `GlobalBus`, `@services/bus`), SEM nenhuma lógica em
 * cima. Extraído de `motor-de-voz.js` (voz v3, 08/09) pra `motor-de-voz.js`,
 * `vad-de-voz.js` e `fala-da-ia.js` poderem importar o MESMO objeto sem
 * import circular entre eles — `motor-de-voz.js` continua sendo quem
 * re-exporta `motorDeVoz` pros consumidores (`send-message.vue`,
 * `view-chat.vue`), então nenhum import externo muda.
 */
import Vue from 'vue'

export const motorDeVoz = new Vue({
  data() {
    return {
      gravando: false,
      modoDeVoz: false,
      microfoneMutado: false,
      nivelDoMicrofone: 0,
      transcrevendo: false,
      // 'usuario' | 'ia' | null.
      estadoDaFala: null,
      /**
       * [feedback do usuário, 04/09] "no fee fixo voce fala e com um tempo a
       * mensagem ja vai e vira uma conversa mesmo com a IA, bem estilo
       * chatgpt" — `true` do clique na bolha roxa até o usuário sair de
       * VERDADE (X ou Esc). Enquanto `true`, o turno seguinte reabre o mic
       * sozinho assim que a IA termina de falar (`fala-da-ia.js`), e o
       * barge-in (`motor-de-voz.js`) fica de escuta enquanto ela fala.
       * O auto-envio por VAD NUNCA zera isto — só ele mantém a conversa
       * andando; só X/Esc encerram.
       */
      sessaoDeVozAtiva: false,
    }
  },
})
